import {
  BankOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileTextOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
  Upload,
  DatePicker,
  Checkbox,
  Radio,
  Tabs,
} from 'antd'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { blue } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import FileItem from '../../../../components/Common/FileItemComponent/FileItem'
import RichEditor from '../../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  PROPOSAL_TYPE,
  DATE_FORMAT_LIST,
  ISO_DATE_FORMAT,
} from '../../../../constants'
import utils from '../../../../utils'
import ApprovalList from '../../../Administrative/LeaveForm/ApproverListModal/Modal'
import DraggerUploadButton from '../../../../components/Common/DraggerUploadButton'
import {
  FormActionFooter,
  OriginFilesList,
  SelectList,
} from '../../../MissionEditPage/MissionEditPageStyled'
import { submissionMenu } from '../ProposalPage/ProposalPage'
import moment from 'moment'
import NumericInput from '../../../../components/Common/NumericInput'
import validator from './../../../../validator'

const { RangePicker } = DatePicker

const ProposalDetailUpdate = props => {
  const {
    proposalStore,
    selectPeopleStore,
    fileStore,
    proposalType,
    proposalTypeStore,
    name,
  } = props

  const {
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    selectUserData,
    selectDepartmentData,
    selectGroupData,
  } = selectPeopleStore

  const [form] = Form.useForm()

  const CONTENT_REF = useRef()

  const [fileList, setFileList] = useState([])
  const [editorContent, setEditorContent] = useState()
  const [followerList, setFollowerList] = useState([])
  const [applyBieuMau, setApplyBieuMau] = useState(false)

  const { formInputTemplate, otherDetail, formProposalType } = proposalStore
  const [originFiles, setOriginFiles] = useState([])

  const [isUpdating, setIsUpdating] = useState(false)

  const defaultDateRange =
    otherDetail.from_date != null
      ? otherDetail.from_date === ''
        ? []
        : [
            moment(otherDetail.from_date, ISO_DATE_FORMAT),
            moment(otherDetail.to_date, ISO_DATE_FORMAT),
          ]
      : []
  // const defaultDateRange =
  //   otherDetail.from_date != null
  //     ? [
  //         moment(otherDetail.from_date, ISO_DATE_FORMAT),
  //         moment(otherDetail.to_date, ISO_DATE_FORMAT),
  //       ]
  //     : []

  useEffect(() => {
    if (!otherDetail.id) return

    form.setFieldsValue({
      title: otherDetail.title,
      proposal_type: name,
    })

    setEditorContent(otherDetail.reason)

    let followerList = []

    otherDetail.followers.forEach(follower => {
      if (follower?.user_name) {
        followerList.push({
          assignee_type: ASSIGNEE_TYPE.USER,
          full_name: follower.name_lowercase.toUpperCase(),
          id: follower.user_name,
          image_id: follower.image_id,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        })
      }
    })

    if (followerList.length > 0) {
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        VIEW: followerList,
      })
    }

    setOriginFiles(otherDetail.attachments)
    ;(async () => {
      await proposalStore.getProposalTypeApprovalConfig(
        otherDetail.proposal_type
      )
    })()

    return () => {
      selectPeopleStore.clearSelectUserData('VIEW')
    }
  }, [])

  const handleChangeFile = useCallback(
    info => {
      const filteredFileList = info.fileList.filter(
        (elem, index, fileArray) =>
          fileArray.findIndex(file => file.name === elem.name) === index
      )
      setFileList(filteredFileList)
    },
    [fileList]
  )

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const onApplyBieuMauChange = value => {
    setApplyBieuMau(value)
    if (value) {
      if (formInputTemplate) {
        setEditorContent(formInputTemplate)
      }
    }
  }

  const onFinish = async values => {
    const uploadFileList = fileList
      ? fileList.map(file => file.originFileObj)
      : []

    const batchUploadArr = []

    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    const response = await Promise.all(batchUploadArr)

    const originFileList = (otherDetail.attachments || []).map(
      file => file.file_id
    )
    const afterFileList = [
      ...response.map(el => el.data.file_id),
      ...originFiles.map(file => file.file_id),
    ]

    let newAttachments = []
    let removeAttachments = []

    afterFileList.forEach(file => {
      if (!originFileList.includes(file)) {
        newAttachments.push(file)
      }
    })
    originFileList.forEach(file => {
      if (!afterFileList.includes(file)) {
        removeAttachments.push(file)
      }
    })

    const removeFollowers = otherDetail.followers.filter(follower => {
      if (!followerList.some(item => item.id === follower.user_name)) {
        return follower
      }
    })

    const newFollowers = followerList.filter(follower => {
      if (!otherDetail.followers.some(item => item.user_name === follower.id)) {
        return follower
      }
    })

    let fromDate =
      values?.date_picker && values?.date_picker.length == 2
        ? moment(values?.date_picker[0]).format(ISO_DATE_FORMAT)
        : defaultDateRange.length > 0
        ? moment(defaultDateRange[0]).format(ISO_DATE_FORMAT)
        : ''
    let toDate =
      values?.date_picker && values?.date_picker.length == 2
        ? moment(values?.date_picker[1]).format(ISO_DATE_FORMAT)
        : defaultDateRange.length > 0
        ? moment(defaultDateRange[1]).format(ISO_DATE_FORMAT)
        : ''
    let proposal = {
      ...values,
      code: otherDetail.proposal_code,
      title: values.title.replace(/\s+/g, ' ').trim(),
      proposal_type: otherDetail.proposal_type,
      attachments: {
        remove_items: removeAttachments,
        new_items: newAttachments,
      },
      assignees: {
        remove_items: removeFollowers.map(follower => ({
          assignee_code: follower.user_name,
          assignee_type: 'USER',
          permission: 'VIEW',
        })),
        new_items: newFollowers.map(follower => ({
          assignee_code: follower.id,
          assignee_type: 'USER',
          permission: 'VIEW',
        })),
      },
      reason_for_leaving: reasonForLeaving,
      type_of_leave: values?.type_of_leave,
      from_date: fromDate,
      to_date: toDate,
      overtime: overtime,
      reason: CONTENT_REF.current.editor.getData(),
    }

    try {
      setIsUpdating(true)
      await proposalStore.updateProposal(proposal)
      await proposalStore.getOtherDetail(proposal.code)
      message.success('Chỉnh sửa thành công!')
    } catch (error) {
      message.error(error.vi || 'Có lỗi xảy ra')
      console.log(error)
    } finally {
      setIsUpdating(false)
      props.onCancel()
    }
  }
  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])
  useEffect(() => {
    ;(async () => {
      const response = await proposalTypeStore.getProposalTypes()
      const newProposalTypes = [
        {
          id_group: '3',
          name_group: 'Hành chính - Khác',
          child: response.data
            .filter(item => item.id.includes('OTHER_'))
            .map(item => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ]
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes)
      setArrSubmissionMenu(updatedSubmissionMenu)
    })()
  }, [])
  const showSubmissionMenu = useMemo(() => {
    return arrSubmissionMenu?.length >= 3 ? (
      arrSubmissionMenu?.map((unit, index) => {
        return (
          <Select.OptGroup
            label={
              <b
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: '#000',
                }}>
                {unit.name_group}
              </b>
            }
            key={unit.id_group}>
            {unit?.child.map(child => {
              return (
                <Select.OptGroup value={child.id_child} key={child.id_child}>
                  {child.name_child}
                </Select.OptGroup>
              )
            })}
          </Select.OptGroup>
        )
      })
    ) : (
      <></>
    )
  }, [arrSubmissionMenu])
  const [reasonForLeaving, setReasonForLeaving] = useState(
    otherDetail.reason_for_leaving
  )

  const handleChangeReasonForLeaving = value => {
    setReasonForLeaving(value.target.checked ? value.target.value : null)
  }

  const [overtime, setOvertime] = useState(otherDetail?.overtime)

  const handleChangeOvertime = value => {
    if (value <= 12) {
      setOvertime(value)
    }
  }

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)

  const handleCheckboxChange = event => {
    setIsCheckboxChecked(event.target.checked)
  }
  return (
    <>
      <Form
        scrollToFirstError={true}
        form={form}
        name={'phieu-trinh-khac-form'}
        layout={'vertical'}
        onFinish={onFinish}>
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <Form.Item name={'proposal_type'} label={'Loại:'}>
              <Input disabled value={name} className="h-40" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item
              name={'title'}
              label={'Tiêu đề:'}
              rules={[
                { required: true, message: 'Vui lòng nhập tiêu đề' },
                {
                  max: 500,
                  message: 'Tiêu đề không được dài quá 500 kí tự!',
                },
                { validator: validator.validateInputString },
              ]}>
              <Input className="h-40" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item
              initialValue={defaultDateRange}
              name={'date_picker'}
              label={'Thời gian:'}
              //tạm thời khóa
              rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}>
              <RangePicker
                // defaultValue={defaultDateRange}
                format={DATE_FORMAT_LIST}
                style={{ width: '100%' }}
                className="h-40"
              />
            </Form.Item>
          </Col>

          {proposalType === 'LEAVE_ABNORMAL' && (
            <Col xs={24} lg={24}>
              <label>Lý do:</label>
              <br />
              <Checkbox.Group
                style={{ marginTop: '8px', marginBottom: '8px' }}
                value={reasonForLeaving}>
                <Checkbox
                  value={'Theo chế độ'}
                  onChange={handleChangeReasonForLeaving}>
                  Theo chế độ
                </Checkbox>
                <Checkbox
                  value={'Lý do cá nhân'}
                  onChange={handleChangeReasonForLeaving}>
                  Lý do cá nhân
                </Checkbox>
                <Checkbox
                  value={'Lý do công việc'}
                  onChange={handleChangeReasonForLeaving}>
                  Lý do công việc
                </Checkbox>
              </Checkbox.Group>
            </Col>
          )}
          {proposalType === 'LEAVE' && (
            <Col xs={24} lg={24}>
              <Form.Item
                label={'Loại nghỉ phép:'}
                name={'type_of_leave'}
                rules={[
                  { required: true, message: 'Vui lòng chọn loại nghỉ phép' },
                ]}
                initialValue={otherDetail?.type_of_leave}>
                <Radio.Group style={{ marginTop: '8px', marginBottom: '8px' }}>
                  <Radio value={'Nghỉ phép 1/2 ngày công'}>
                    Nghỉ phép 1/2 ngày công
                  </Radio>
                  <Radio value={'Nghỉ phép theo chế độ'}>
                    Nghỉ phép theo chế độ
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          )}
          {(proposalType === 'OVERTIME_NORMAL' ||
            proposalType === 'OVERTIME_DAYOFF' ||
            proposalType === 'OVERTIME_HOLIDAY') && (
            <>
              <Col xs={24} lg={24}>
                <label>Thêm số giờ làm việc:</label>
                <Checkbox
                  style={{ marginLeft: '5px', paddingTop: '5px' }}
                  checked={isCheckboxChecked}
                  onChange={handleCheckboxChange}></Checkbox>
                <br />
                <NumericInput
                  value={overtime}
                  onChange={handleChangeOvertime}
                  disabled={!isCheckboxChecked}
                />
              </Col>
            </>
          )}


        </Row>

        <Tabs
          defaultActiveKey="1"
          destroyInactiveTabPane={false}
          style={{
            marginTop: 20,
          }}>
          <Tabs.TabPane tab="Nội dung" key="1" forceRender>
            <Form.Item
              label={
                <div>
                  <p>Nội dung:</p>
                </div>
              }>
              <RichEditor
                key={editorContent}
                EDITOR_REF={CONTENT_REF}
                placeholder={'Nhập nội dung'}
                editorContent={editorContent}
              />
            </Form.Item>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Tài liệu đính kèm" key="2" forceRender>
            <Form.Item name={'file_ids'} label={'Tài liệu đính kèm:'}>
              <Upload.Dragger
                valuePropName={'fileList'}
                fileList={fileList}
                multiple={true}
                onChange={handleChangeFile}
                beforeUpload={() => false}
                className="custom-dragger-upload bg-white">
                <DraggerUploadButton />
              </Upload.Dragger>
            </Form.Item>

            <OriginFilesList>
              {originFiles.map(file => (
                <div className={'file'} key={file.file_id}>
                  <FileItem
                    file_id={file.file_id}
                    file_name={file.file_name}
                    file_type={utils.getExtensionFile(file.file_name)}
                  />
                  <span
                    className={'delete-icon'}
                    style={{ marginRight: '5px' }}
                    onClick={() =>
                      setOriginFiles(
                        originFiles.filter(el => el.file_id !== file.file_id)
                      )
                    }>
                    <DeleteOutlined />
                  </span>
                </div>
              ))}
            </OriginFilesList>
          </Tabs.TabPane>
        </Tabs>

        <ApprovalList />
        <SelectPeoplePopup
          disableSelectDepartment
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />

        <FormActionFooter style={{ display: 'flex', justifyContent: 'center' }}>
          <Button className="custom-ant-button w-160" danger onClick={props.onCancel}>
            Huỷ bỏ
          </Button>
          <Button
            loading={isUpdating}
            style={{ marginLeft: 10 }}
            className="custom-ant-button w-160"
            type={'primary'}
            htmlType={'submit'}>
            Đồng ý chỉnh sửa
          </Button>
        </FormActionFooter>
      </Form>
    </>
  )
}

ProposalDetailUpdate.propTypes = {
  onCancel: PropTypes.func.isRequired,
  // code: PropTypes.string.isRequired,
  showSubmissionMenu: PropTypes.func,
}
export default inject(
  'proposalStore',
  'selectPeopleStore',
  'fileStore',
  'proposalTypeStore'
)(observer(ProposalDetailUpdate))
